(() => {
  if (window.veroferaInitialized) return;
  window.veroferaInitialized = true;
  document.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-vf-filter]');
    if (filter) {
      const section = filter.closest('.vf-products');
      if (!section) return;
      const format = filter.dataset.vfFilter;
      let count = 0;
      section.querySelectorAll('[data-vf-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === filter));
      });
      section.querySelectorAll('[data-vf-format]').forEach((card) => {
        card.hidden = format !== 'all' && card.dataset.vfFormat !== format;
        if (!card.hidden) count += 1;
      });
      const status = section.querySelector('[data-vf-filter-status]');
      if (status) status.textContent = status.dataset.message.replace('{count}', String(count));
    }
    const menuLink = event.target.closest('.vf-mobile-menu a');
    if (menuLink) menuLink.closest('details').open = false;
    document.querySelectorAll('.vf-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.vf-mobile-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
})();
